import {z as r} from 'zod';

import {CalendarPostStatusEnum} from '../posts/posts-types';

export enum CalendarPublicationTypeEnum {
    post = 'post',
    story = 'story',
    promotion = 'promotion',
    event = 'event',
}

export enum CalendarModerationEnum {
    onModeration = 'on_moderation',
    rejected = 'rejected',
}

const calendarPublicationEntrySchema = r.object({
    id: r.number(),
    name: r.string(),
    type: r.nativeEnum(CalendarPublicationTypeEnum),
    moderation: r.nativeEnum(CalendarModerationEnum).nullable(),
});

export type CalendarPublicationEntryType = r.infer<typeof calendarPublicationEntrySchema>;

const calendarPublicationsRecordSchema = r
    .record(r.nativeEnum(CalendarPostStatusEnum), r.array(calendarPublicationEntrySchema))
    .optional();

// Same shape as the posts calendar: keyed by day (month view) or by month (year view), then by
// status bucket. The backend keeps both responses aligned so they can be merged as-is.
const calendarPublicationsSchema = r.record(r.number(), calendarPublicationsRecordSchema);

export type CalendarPublicationsResponseType = r.infer<typeof calendarPublicationsSchema>;

export type CalendarPublicationsRequestParametersType = {
    year: number;
    month: number | null;
};
